<template>
    <div v-if="session">
        <top-navbar :breadcrumb="$route.params.groupId != 0 ? groupBreadcrumb : cohortBreadcrumb"></top-navbar>

        <div class="container-fluid mt--6">
            <div class="row">
                <div class="col-11">
                    <simulation
                        v-model="session"
                        :registration="registration"
                        :simulation="simulation">
                    </simulation>
                    <log-content
                        :log="log"
                        :types="types"
                        :registration="registration"
                        :simulation="simulation"
                        :session="session"
                        :stats="stats"
                        :competencies="competencies"
                        :grid-competencies="gridCompetencies"
                        :lang="registration.degree.lang"
                        :redirect="redirect"
                        :filters="filters"
                        @filtersChanged="filters = $event"
                        @refresh="refresh">
                    </log-content>
                </div>
                <div class="col-1">
                    <features
                        :log="log"
                        :registration="registration"
                        :simulation="simulation"
                        :session="session"
                        :stats="stats"
                        :competencies="competencies"
                        :grid-competencies="gridCompetencies"
                        :lang="registration.degree.lang"
                        :types="types"
                        :filters="filters"
                        @filtersChanged="filters = $event"
                        @refresh="refresh">
                    </features>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Simulation from './log/Simulation'
    import LogContent from './log/LogContent'
    import Features from './log/GlobalFeatures'

    export default {

        components: {
            Simulation, LogContent, Features
        },

        data() {
            return {
                log: null,
                registration: null,
                simulation: null,
                session: null,
                types: null,
                competencies: null,
                gridCompetencies: null,
                stats: null,
                filters: {
                    selectedTypes: [],
                    showCompetencies: false,
                    position1: true,
                    position2: true,
                },
            }
        },

        computed: {

            redirect() {
               if (this.$route.params.groupId && this.$route.params.groupId != 0) {   // Important.
                    return {
                        name: 'dashboard-group-simulation',
                        params: {
                            groupId: this.$route.params.groupId,
                            registrationId: this.registration.id,
                            simulationId: this.simulation.id
                        }
                    }
               } else {
                    return {
                        name: 'dashboard-cohort-simulation',
                        params: {
                            cohortId: this.registration.cohort.id,
                            registrationId: this.registration.id,
                            simulationId: this.simulation.id
                        }
                    }
               }
            },

            groupBreadcrumb() {
                return [
                    {
                        name: this.registration.cohort.name,
                        route: '/astral/ui/dashboard/cohorts/' + this.registration.cohort_id
                    },
                    {
                        name: this.registration.degree.name,
                        route: '/astral/ui/dashboard/registrations/' + this.$route.params.registrationId + '/groups/' + this.$route.params.groupId
                    },
                    {
                        name: this.simulation.name,
                        route: '/astral/ui/dashboard/registrations/' + this.$route.params.registrationId + '/simulations/' + this.$route.params.simulationId + '/groups/' + this.$route.params.groupId
                    },
                    {
                        name: this.$t('common.log'),
                    },
                ]
            },

            cohortBreadcrumb() {
                return [
                    {
                        name: this.registration.cohort.name,
                        route: '/astral/ui/dashboard/cohorts/' + this.registration.cohort_id
                    },
                    {
                        name: this.registration.degree.name,
                        route: '/astral/ui/dashboard/registrations/' + this.$route.params.registrationId + '/cohorts/' + this.registration.cohort_id
                    },
                    {
                        name: this.simulation.name,
                        route: '/astral/ui/dashboard/registrations/' + this.$route.params.registrationId + '/simulations/' + this.$route.params.simulationId + '/cohorts/' + this.registration.cohort_id
                    },
                    {
                        name: this.$t('common.log'),
                    },
                ]
            },
        },

        beforeRouteEnter(to, from, next) {
            Vue.prototype.$loader.show()
            axios.get('/astral/api/front/dashboard/sessions/'+to.params.sessionId+'/log')
            .then(resp => {
                next(vm => {
                    vm.log = resp.data.data
                    vm.registration = resp.data.included.registration
                    vm.simulation = resp.data.included.simulation
                    vm.types = resp.data.included.types
                    vm.competencies = resp.data.included.competencies
                    vm.gridCompetencies = resp.data.included.grid_competencies
                    vm.$navigation.setLastSimulation(vm.registration, vm.simulation)
                    vm.$permissions.setRights(resp.data.included.rights)
                    vm.refresh(resp.data.included.session.id)
                })
            })
            .catch(err => {
                if (err.response.status == 403) {
                    Vue.prototype.$loader.hide()
                    next({ name: 'unauthorized' });
                } else if (err.response.status == 444) {
                    next({ name: 'home' });
                }
            });
        },

        methods: {

            refresh(sessionId = null) {
                if (!sessionId) {
                    sessionId = this.session.id
                }
                axios.get('/astral/api/front/dashboard/sessions/'+sessionId+'/log/stats')
                .then(resp => {
                    this.$loader.hide()
                    this.stats = resp.data.data
                    this.session = resp.data.included.session
                })
                .catch(err => {
                    this.$auth.handleErrorVm(err, this)
                })        
            },
        }
    }
</script>
